export const NUMBER_OF_TEAMS_LIMIT = 10
export const NUMBER_OF_LOCATIONS_LIMIT = 3
export const WORKING_HOURS_IN_DAY = 8
